import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import BackgroundImage from '../background-image/background-image';
import Tagline from '../tagline/tagline';
import type { BecomeMemberModule as Props } from './become-member-module.types';

/** https://www.figma.com/design/dQeQgh6sANMhWBUNtgXQNN/satsweb-components?node-id=8128-7028 */
const BecomeMemberModule: React.FC<Props> = ({
  actions,
  background,
  body,
  tagline,
  title,
}) => (
  <div className="become-member-module">
    {background ? (
      <div aria-hidden className="become-member-module__background">
        <BackgroundImage {...background} />
      </div>
    ) : null}
    <div className="become-member-module__foreground">
      <div className="become-member-module__tagline">
        <Tagline {...tagline} onDark />
      </div>
      <div className="become-member-module__title">
        <Text italic size={Text.sizes.headline2} theme={Text.themes.headline}>
          {title}
        </Text>
      </div>
      <div className="become-member-module__body">
        <Text theme={Text.themes.emphasis}>{body}</Text>
      </div>
      <div className="become-member-module__actions">
        {actions.map((entry, index) => (
          <div className="become-member-module__action" key={entry.href}>
            <LinkButton
              {...entry}
              size={LinkButton.sizes.large}
              variant={
                index
                  ? LinkButton.variants.ctaSecondaryWhite
                  : LinkButton.variants.cta
              }
              wide
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default BecomeMemberModule;
